jQuery(document).ready(function ($) {
  const clientLoginBtn = $(".mb-client-login-btn");

  const campaignDetailsName = "campaignDetails";
  const campaignIdsName = "campaignIds";
  const oneMonthCampaign = "1mf";

  initCampaignStorage();

  function initCampaignStorage() {
    const cidParam = getParamFromURL("cid");
    var campaignIdsStorage = localStorage.getItem(campaignIdsName);
    var campaignDetailsStorage = localStorage.getItem(campaignDetailsName);

    if (campaignIdsStorage === null) {
      campaignIdsStorage = JSON.stringify([]);
      localStorage.setItem(campaignIdsName, campaignIdsStorage);
    }

    // check url and update
    if (
      cidParam ||
      campaignDetailsStorage === null ||
      getCurrentPagePath().toLowerCase().indexOf(oneMonthCampaign) !== -1
    ) {
      saveCidInfoInCampaignDetails(cidParam);
    }

    if (
      cidParam &&
      !ifCampaignIdExistInStorage(JSON.parse(campaignIdsStorage), cidParam)
    ) {
      saveCidInCampaignIds(JSON.parse(campaignIdsStorage), cidParam);
      // Put cid into localstorage campaignDetails
      // Put cid into localstorage campaignIds
    }
  }

  function getCurrentPagePath() {
    var currentPath = window.location.pathname;
    return currentPath.replace(/\\|\//g, "");
  }

  function ifCampaignIdExistInStorage(campaignIds, cidParam) {
    // To Support IE 11
    return (
      campaignIds.filter(function (e) {
        return e.id.toUpperCase() === cidParam.toUpperCase();
      }).length > 0
    );
  }

  function getParamFromURL(param) {
    const paramLower = param;
    const paramUpper = param.toUpperCase();
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      // IE 11 support
      const params = {};
      window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (_, key, value) {
          return (params[key] = value);
        }
      );

      return params[paramLower]
        ? decodeURIComponent(params[paramLower])
        : params[paramUpper]
          ? decodeURIComponent(params[paramUpper])
          : "";
    } else {
      const params = new URL(document.location).searchParams;
      // Params are case sensitive
      return params.get(paramLower)
        ? decodeURIComponent(params.get(paramLower))
        : params.get(paramUpper)
          ? decodeURIComponent(params.get(paramUpper))
          : "";
    }
  }

  function saveCidInCampaignIds(existingCIDsArray, cid) {
    const now = new Date();
    const zuluFormatted = now.toJSON(); // return ISO-8601 standard: YYYY-MM-DDTHH:mm:ss.sssZ

    // Adding CID to existing array.
    if (existingCIDsArray && existingCIDsArray.length) {
      const cidObj = { id: cid.toUpperCase(), createdDate: zuluFormatted };
      existingCIDsArray.push(cidObj);
      // Update local storage with new array.
      localStorage.removeItem(campaignIdsName);
      localStorage.setItem(campaignIdsName, JSON.stringify(existingCIDsArray));
    } else {
      // Set item for the first time
      const campaignIds = [];
      const cidObj = { id: cid.toUpperCase(), createdDate: zuluFormatted };
      campaignIds.push(cidObj);
      localStorage.setItem(campaignIdsName, JSON.stringify(campaignIds));
    }
  }

  function saveCidInfoInCampaignDetails(cidParam) {
    var campaignDetailsStorage = {};

    campaignDetailsStorage.id = cidParam ? cidParam.toUpperCase() : "";

    const source = getParamFromURL("utm_source");
    campaignDetailsStorage.source = source ? source.toLowerCase() : "";

    const medium = getParamFromURL("utm_medium");
    campaignDetailsStorage.medium = medium ? medium.toLowerCase() : "";

    const keyword = getParamFromURL("keyword");
    campaignDetailsStorage.adKeyword = keyword ? keyword.toLowerCase() : "";

    campaignDetailsStorage.url = document.location.href;

    localStorage.setItem(
      campaignDetailsName,
      JSON.stringify(campaignDetailsStorage)
    );

    // Push to Google tag manager
    dataLayer.push({
      event: "init_user",
      mb_campaign_id_last: campaignDetailsStorage.id,
      mb_ads_keyword_last: campaignDetailsStorage.adKeyword,
      mb_ads_pathway_last: campaignDetailsStorage.url,
    });
  }

  clientLoginBtn.click(function (event) {
    setCookie("mb_client_login", "true", 365);
  });

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  // Start of capturing GCLID
  // https://support.google.com/google-ads/answer/7012522
  function getParam(p) {
    var match = RegExp("[?&]" + p + "=([^&]*)").exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
  }

  function getExpiryRecord(value) {
    var expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds

    var expiryDate = new Date().getTime() + expiryPeriod;
    return {
      value: value,
      expiryDate: expiryDate,
    };
  }

  function addGclid() {
    var gclidParam = getParam("gclid");
    var gclidRecord = null;

    var gclsrcParam = getParam("gclsrc");
    var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf("aw") !== -1;

    if (gclidParam && isGclsrcValid) {
      gclidRecord = getExpiryRecord(gclidParam);
      localStorage.setItem("gclid", JSON.stringify(gclidRecord));
    }
  }
  window.addEventListener("load", addGclid);
});
